import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { resetSession } from 'utils/functions/resetSession';

function PublicRoute() {
  useEffect(() => {
    // waits 4 seconds to remove the hubspot widget at public routes
    setTimeout(() => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.remove();
      }
    }, 4000);

    resetSession();
  }, []);

  return <Outlet />;
}

export default PublicRoute;
